import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const RequestAccessPopupComponent: LoadableType<
	Omit<
		{
			contentId: string;
			flags: FlagsStateContainer;
		},
		'flags'
	>
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RequestAccessPopup" */ './RequestAccessPopup.tsx'))
			.RequestAccessPopupComponent,
});
